module.exports = __webpack_public_path__ + "media/images/character/zen_chan_back-b4375523daa18dc437bc7d5cbeced85d.png";